import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const u = await login(email, password);
            toast.success(`Welcome back, ${u.full_name}`);
            const dest = u.role === "admin" ? "/admin" : (loc.state?.from || "/dashboard");
            nav(dest, { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-[calc(100vh-8rem)] flex">
            <div className="hidden lg:block lg:w-1/2 relative border-r border-border">
                <div className="absolute inset-0 grid-lines opacity-40" />
                <div className="relative h-full flex flex-col justify-between p-12">
                    <div>
                        <span className="overline text-primary">▮ Login</span>
                        <h2 className="mt-6 font-heading font-black text-5xl leading-tight tracking-tighter">
                            Return to <br />the <span className="text-primary">grind.</span>
                        </h2>
                    </div>
                    <p className="font-mono text-xs text-muted-foreground max-w-md">
                        Prepcheck is developed by Illume AI Innovations Pvt Ltd. Admin access is provisioned from secure server environment credentials.
                    </p>
                </div>
            </div>

            <div className="flex-1 flex items-center justify-center p-6">
                <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="login-form">
                    <h1 className="font-heading font-black text-3xl tracking-tighter">Sign in</h1>
                    <p className="mt-2 text-sm text-muted-foreground">
                        No account? <Link className="text-primary underline underline-offset-4" to="/register">Create one</Link>
                    </p>

                    <div className="mt-8 space-y-4">
                        <div>
                            <Label className="overline">Email</Label>
                            <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-2" />
                        </div>
                        <div>
                            <Label className="overline">Password</Label>
                            <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm mt-2" />
                        </div>
                        <Button data-testid="login-submit-btn" type="submit" disabled={busy} className="w-full rounded-sm bg-primary hover:bg-primary/90 btn-press">
                            {busy ? "Signing in…" : "Sign in"}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
